import { Component, Input, OnInit } from '@angular/core';
import { WindowStatus } from 'src/app/enums/window-status.enum';
import { IWindowProcess } from 'src/app/interfaces/os/window-process.interface';
import { WindowsManagerService } from 'src/app/services/os/windows-manager.service';

@Component({
  selector: 'app-windows-layer',
  templateUrl: './windows-layer.component.html',
  styleUrls: ['./windows-layer.component.scss']
})
export class WindowsLayerComponent implements OnInit {
  @Input() allWindows: IWindowProcess[] = [];

  constructor(private windowMgr: WindowsManagerService) {
  }

  get hasMaximizedWindow(): boolean {
    return this.allWindows.some(m => m.isMaximized());
  }

  get maximizedWindowId(): number {
    return this.allWindows.find(m => m.isMaximized()).id;
  }

  ngOnInit() {
  }

  windowsId(_index: number, item: IWindowProcess) {
    return item.id;
  }

  focus(window: IWindowProcess): void {
    this.windowMgr.focus(window);
  }

  getZ(window: IWindowProcess) {
    return window.extra.z || 0;
  }
}
